import { BsCartXFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";

const NoItem = ({message}) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center bg-white shadow-sm border border-slate-100">
      {/* Icon */}
      <div className="bg-blue-50 p-6 rounded-full mb-6">
        <BsCartXFill className="w-16 h-16 sm:w-20 sm:h-20 text-[#265fc9]" />
      </div>

      {/* Title */}
      <h3 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">
        কোনো পণ্য পাওয়া যায়নি
      </h3>

      {/* Subtitle */}
      <p className="text-sm sm:text-base text-gray-500 mb-6 max-w-md">
        {message}
      </p>

      {/* Button */}
      <button
        onClick={() => navigate("/")}
        className="bg-[#265fc9] hover:bg-[#1e4db3] text-white px-6 py-2.5 rounded-lg text-sm sm:text-base font-medium transition-all duration-200"
      >
        পণ্য ব্রাউজ করুন
      </button>
    </div>
  );
};

export default NoItem;
